<template>
  <div class="row">
    <div
      v-for="(column, index) in columns"
      :key="index"
      class="taskmanager-column margin-vertical-tiny padding-horizontal-normal col-md-4 col-12"
    >
      <div class="taskmanager-column-content padding-horizontal-tiny padding-vertical-big bg-white-darker-2 border-radius">
        <h3 class="align-center ink-base regular font-size-big margin-bottom-normal">
          {{ column.title }}
        </h3>

        <BButton
          v-if="index == 0"
          class="font-size-big margin-top-normal  margin-bottom-big w100"
          link
          color="blue"
          @clickOrEnter="addAction"
        >+ Adicionar etapa
        </BButton>

        <Draggable
          item-key="order"
          class="list-group"
          group="task"
          :list="column.tasks"
          @change="taskMoveAction($event, column._id)"
        >
          <BCard
            class="task w100 padding-horizontal-big padding-vertical-tiny margin-bottom-tiny"
            v-for="(task, index) in column.tasks"
            :key="index"
          >
            <BHoveringMenu
              v-if="menuOptions && menuOptions.length"
              :options="menuOptions(task)"
              @click.native.stop.prevent
            />
            <div class="display-flex flex-row-md flex-column">
              <p class="semi-bold margin-right-big font-size-big">{{ task.title }}</p>
            </div>
          </BCard>
        </Draggable>
      </div>
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import { BCard, BHoveringMenu, BButton } from '@bossabox-code/design-system';

export default {
	name: 'TaskManager',
	components: {
		Draggable,
		BCard,
		BHoveringMenu,
		BButton
	},
	props: {
		columns: {
			type: Array,
			default: () => [],
			required: true
		}
	},
	methods: {
		menuOptions(task) {
			let menuOptions = [];
			menuOptions.push({
				icon: 'icon-create',
				text: 'Editar',
				color: 'ink-lighter-1',
				method: this.editAction,
				params: task
			});
			menuOptions.push({
				icon: 'icon-delete',
				text: 'Deletar',
				color: 'red-base',
				method: this.removeAction,
				params: task
			});
			return menuOptions;
		},
		addAction() {
			this.$emit('add-action');
		},
		editAction(task) {
			this.$emit('edit-action', task);
		},
		removeAction(task) {
			this.$emit('remove-action', task);
		},
		taskMoveAction(evt, newColumnId) {
			if (Object.keys(evt).includes('added') || Object.keys(evt).includes('moved')) {
				const elem = evt.added || evt.moved;
				this.$emit('task-moved-action', {
					taskId: elem.element._id,
					position: elem.newIndex,
					columnId: newColumnId
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.list-group,
.taskmanager-column-content {
	min-height: 70vh;
}

.taskmanager-column:first-child {
	padding-left: 0;
}

.taskmanager-column-content:first-child {
	margin-left: 0;
}

.taskmanager-column:last-child {
	padding-right: 0;
}

.taskmanager-column-content:last-child {
	margin-right: 0;
}

.task:hover {
	.menu {
		display: block;
	}
}

.menu {
	display: none;
	float: right;
	margin-right: -2.5rem;
}

.menu:hover {
	cursor: pointer;
}
</style>
